import React, { Component } from 'react';
import { ProgramasListItem } from './ProgramasLisItem';
import { ArchivosList } from './ArchivosList';
import { Panel, PanelGroup } from 'react-bootstrap';
import BlockUi from 'react-block-ui';
import { Loader } from 'react-loaders';
import 'react-block-ui/style.css';
import 'loaders.css/loaders.min.css';
import axios from 'axios';

function isVacio(arreglo) {
    if (arreglo.length === 0)
        arreglo = [{ tituloNvo: "No disponible" }];
    return arreglo;
}

function isVacioEsp(arreglo) {
    if (Object.keys(arreglo).length === 0 && arreglo.constructor === Object)
        arreglo = { "x":[{tituloNvo: "No disponible"}] };
    return arreglo;
}

export class ProgramasList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            listaMetodologias: [],
            listaEspecificaciones1: [],
            listaEspecificaciones2: [],
            listaMetadatos: [],
            idPrograma: 0,
            origen: props.origen,
            activeKey:props.activeKey
        };
        this.handleSelect = this.handleSelect.bind(this);
        this.programaClicked = this.programaClicked.bind(this);
    }

    handleSelect(activeKey, bsClass) {
        this.setState({ activeKey });
        const { limpiarConsulta } = this.props;
        limpiarConsulta(activeKey);
    }


    programaClicked(idPrograma, nombre) {
        if (idPrograma == this.state.activeKey) {
            return;
        }
        this.setState({ blocking: true, loaderType: 'ball-triangle-path' });
        this.setState({ listaProgramas: [], listaMetodologias: [], listaEspecificaciones: [], listaMetadatos: [], nombrePrograma: nombre });
        var baseUrl = process.env.REACT_APP_URL_API + '/api/Archivo/';
        var peticionMeto = axios.get(`${baseUrl}Metodologias/${idPrograma}`);
        var peticionEspe1 = axios.get(`${baseUrl}Especificaciones/${idPrograma}/${this.state.origen}`);
        var peticionEspe2 = axios.get(`${baseUrl}Especificaciones/${idPrograma}`);
        var peticionMeta = axios.get(`${baseUrl}Metadatos/${idPrograma}`);

        axios.all([peticionMeto, peticionEspe1, peticionEspe2, peticionMeta]).then(axios.spread((...responses) => {
            const respuestaMeto = responses[0];
            const respuestaEspe1 = responses[1];
            const respuestaEspe2 = responses[2];
            const respuestaMeta = responses[3];
            this.setState({
                listaMetodologias: isVacio(respuestaMeto.data),
                listaEspecificaciones1: isVacioEsp(respuestaEspe1.data),
                listaEspecificaciones2: isVacio(respuestaEspe2.data),
                listaMetadatos: isVacio(respuestaMeta.data)
            });
            
            this.setState({ blocking: false });
        })).catch(err => {
            alert("Ocurrió un error al obtener los documentos");
            this.setState({ blocking: false });
            return null;
        });
        

    }

    render() {
        const { listaProgramas,activeKey } = this.props;

        return (
            <div className="container-fluid">
                <br />
                <PanelGroup 
                    accordion
                    id='panelProgramas'
                    activeKey={activeKey} bsClass='primary'
                    onSelect={this.handleSelect}
                >
                    {listaProgramas.map(res =>
                        <Panel eventKey={res.idPrograma} key={res.idPrograma}>
                            <Panel.Heading>
                                <Panel.Title toggle><ProgramasListItem idPrograma={res.idPrograma} idSubsistema={res.idSubsistema} nombre={res.nombre} programaClicked={this.programaClicked} /></Panel.Title>
                            </Panel.Heading>

                            <Panel.Body collapsible>

                                <BlockUi tag="div" blocking={this.state.blocking} loader={<Loader active type={this.state.loaderType} color="#02a17c" />}>
                                    <ArchivosList listaMetodologias={this.state.listaMetodologias} listaEspecificaciones1={this.state.listaEspecificaciones1} listaEspecificaciones2={this.state.listaEspecificaciones2} listaMetadatos={this.state.listaMetadatos} nombrePrograma={this.state.nombrePrograma} origen={this.state.origen} />
                                </BlockUi>
                            </Panel.Body>
                        </Panel>
                    )}
                </PanelGroup>
            </div>
        );
    }
}
